<template>
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12 2.25C5.78613 2.25 0.75 6.25781 0.75 11.2041C0.75 13.3393 1.69043 15.2937 3.25488 16.8305C2.70557 19.0002 0.868652 20.933 0.84668 20.9546C0.75 21.0536 0.723633 21.1999 0.780762 21.3291C0.837891 21.4582 0.960937 21.5357 1.10156 21.5357C4.01514 21.5357 6.19922 20.1668 7.28027 19.323C8.71729 19.8525 10.3125 20.1582 12 20.1582C18.2139 20.1582 23.25 16.1503 23.25 11.2041C23.25 6.25781 18.2139 2.25 12 2.25Z"
            :fill="color"
        />
        <path
            d="M12 2.25C5.78613 2.25 0.75 6.25781 0.75 11.2041C0.75 13.3393 1.69043 15.2937 3.25488 16.8305C2.70557 19.0002 0.868652 20.933 0.84668 20.9546C0.75 21.0536 0.723633 21.1999 0.780762 21.3291C0.837891 21.4582 0.960937 21.5357 1.10156 21.5357C4.01514 21.5357 6.19922 20.1668 7.28027 19.323C8.71729 19.8525 10.3125 20.1582 12 20.1582C18.2139 20.1582 23.25 16.1503 23.25 11.2041C23.25 6.25781 18.2139 2.25 12 2.25Z"
            fill="url(#paint0_linear_20703_12480)"
            fill-opacity="0.8"
        />
        <path
            d="M12 2.25C5.78613 2.25 0.75 6.25781 0.75 11.2041C0.75 13.3393 1.69043 15.2937 3.25488 16.8305C2.70557 19.0002 0.868652 20.933 0.84668 20.9546C0.75 21.0536 0.723633 21.1999 0.780762 21.3291C0.837891 21.4582 0.960937 21.5357 1.10156 21.5357C4.01514 21.5357 6.19922 20.1668 7.28027 19.323C8.71729 19.8525 10.3125 20.1582 12 20.1582C18.2139 20.1582 23.25 16.1503 23.25 11.2041C23.25 6.25781 18.2139 2.25 12 2.25Z"
            stroke="url(#paint1_linear_20703_12480)"
            stroke-opacity="0.2"
            style="mix-blend-mode: multiply"
        />
        <path
            d="M12.75 6.75V10.25H16.25L11.75 15.75V12.25H8.25L12.75 6.75Z"
            fill="url(#paint2_linear_20703_12480)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_20703_12480"
                x1="12"
                y1="2.25"
                x2="12"
                y2="21.5357"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-opacity="0" />
                <stop offset="1" stop-color="#072B12" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_20703_12480"
                x1="0.75"
                y1="2.25"
                x2="0.75"
                y2="21.5357"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="white" stop-opacity="0.5" />
                <stop offset="1" stop-opacity="0.5" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_20703_12480"
                x1="8.18939"
                y1="11.8125"
                x2="16.1894"
                y2="11.8125"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#CCBB86" />
                <stop
                    offset="0.487274"
                    stop-color="#DBCC93"
                    stop-opacity="0.95"
                />
                <stop offset="1" stop-color="#AF9B62" />
            </linearGradient>
        </defs>
    </svg>
</template>

<script>
export default {
    name: "ExclusiveMessageIcon",
    props: {
        color: {
            type: String,
            default: "#1D2027",
        },
    },
};
</script>
